import CustomerLogin from "../../pages/auth/customer";
import ForgotPassword from "../../pages/auth/forgot-password";
import Login from "../../pages/auth/Login";
import ManagementLogin from "../../pages/auth/management";
import NotFound from "../../pages/auth/NotFound";
import ResetPassword from "../../pages/auth/reset-password";
import TranportAgentLogin from "../../pages/auth/transport-agent";
import TranporterLogin from "../../pages/auth/transporter";
import LogisticHome from "../../pages/pdp/logistics";
import AboutUs from "../../pages/pdp/logistics/aboutUs";
import { GoogleAuthRegisterPage } from "../../pages/pdp/customer/google-register/register";
import { GoogleAuthRegisteredPage } from "../../pages/pdp/customer/google-register/registered";
import CustomerHome from "../../pages/pdp/customer/home";
import { RegisterCustomer } from "../../pages/registrations/customerRegistry";
import { RegisterTransportAgent } from "../../pages/registrations/transportAgentRegistry";
import { RegisterTransporter } from "../../pages/registrations/transporterRegistry";
import { RoleGuard } from "../guards";
import Faq from "../../components/customer/faq";

export const pdpAppRoutes = () => {
	 return ([			
			{ path: "/", element: <RoleGuard roles={["Internal"]}><LogisticHome /></RoleGuard>},
			{ path: "home", element: <RoleGuard roles={["Internal"]}><CustomerHome /></RoleGuard>},
			{ path: "customer/support", element: <RoleGuard roles={["Internal"]}><Faq /></RoleGuard>},
			{ path: "register/transporter", element: <RoleGuard roles={["Internal"]}><RegisterTransporter /></RoleGuard>},
			{ path: "register/customer", element: <RoleGuard roles={["Internal"]}><RegisterCustomer /></RoleGuard>},
			{ path: "register/transport-agent", element: <RoleGuard roles={["Internal"]}><RegisterTransportAgent /></RoleGuard>},
			{ path: "register", element: <RoleGuard roles={["Internal"]}><GoogleAuthRegisterPage /></RoleGuard>},
			{ path: "registered", element: <RoleGuard roles={["Internal"]}><GoogleAuthRegisteredPage /></RoleGuard>},
			{ path: "about-us", element: <RoleGuard roles={["Internal"]}><AboutUs /></RoleGuard>},			
			{ path: "auth/login", element: <RoleGuard roles={["Internal"]}>< Login /></RoleGuard>},
			{ path: "auth/login/transporter", element: <RoleGuard roles={["Internal"]}><TranporterLogin /></RoleGuard>},
			{ path: "auth/login/transport-agent", element: <RoleGuard roles={["Internal"]}><TranportAgentLogin /></RoleGuard>},
			{ path: "auth/login/management", element: <RoleGuard roles={["Internal"]}><ManagementLogin /></RoleGuard>},
			{ path: "auth/login/customer", element: <RoleGuard roles={["Internal"]}><CustomerLogin /></RoleGuard>},
			{ path: "auth/login/forgot-password", element: <RoleGuard roles={["Internal"]}><ForgotPassword /></RoleGuard>},
			{ path: "auth/login/reset-password", element: <RoleGuard roles={["Internal"]}><ResetPassword /></RoleGuard>},
			{ path: "notfound", element: <RoleGuard roles={["Internal"]}>< NotFound /></RoleGuard>},
		])
};
